<template>
  <div v-if="visible">
    <a class="context__menu-item-link" @click="$refs.modal.show()">
      <i class="context__menu-item-icon iconoir-attachment"></i>
      Acceso a los adjuntos
    </a>
    <AccesoAdjuntosModal ref="modal" :table="table" />
  </div>
</template>

<script>
/**
 * "Acceso a los adjuntos" en el menú de una tabla. Solo lo ve el admin del
 * espacio: es el único que decide quién abre los archivos de una tabla
 * (condición de Isaac). El servidor lo vuelve a comprobar.
 */
import AccesoAdjuntosModal from '@extras_mg/components/AccesoAdjuntosModal'
import { permisosDe } from '@extras_mg/utils/roles'

export default {
  name: 'AccesoAdjuntosItem',
  components: { AccesoAdjuntosModal },
  props: {
    database: { type: Object, required: true },
    table: { type: Object, required: true },
  },
  computed: {
    visible() {
      const permisos = permisosDe(
        this.$store,
        this.database.workspace.id,
        'mg_roles'
      )
      return permisos?.rol_espacio === 'ADMIN'
    },
  },
}
</script>
